import React, { useEffect, useState, useContext } from 'react';
import MenuScreen from '../common/menu-screen';
import AuthorityScreen from '../common/authority-screen';
import InfoScreen from '../components/lm-d-s/info-screen';
import CharacteristicScreen from '../common/characteristic-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import styles from '../components/chesterfield/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import WelcomeChallengeScreen from '../common/challenge-component/welcome-challenge-screen';
import TwoImageSelectChallenge from '../common/challenge-component/two-image-select-challenge';
import ResultInfoScreen from '../common/challenge-component/result-info-screen';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import {
  decemberChallengeList,
  decemberResultList,
  februaryChallengeList,
  februaryResultList,
  januaryChallengeList,
  januaryResultList,
  novemberResultList,
  octoberChallengeList,
  octoberResultList,
  septemberChallengeList,
  septemberResultList
} from '../consts/chesterfield-challenge';
import OnlyImageChallenge from '../common/challenge-component/only-image-challenge';
import SwipeChallenge from '../common/challenge-component/swipe-challenge';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';
import PredictionScreen from '../common/prediction-screen';
import MemoryChallenge from '../components/special-capsules/challenge/memory-select-challenge';
import { getImageFromS3 } from '../imageService';
import ReviewFlowScreen from '../common/review-flow-screen';
import { CURRENT_CHALLENGE_NAME } from '../consts/challengeName';
import useScreenHistory from '../hooks/useScreenHistory';

const PROJECT_NAME = '4 Silver';

const filterCharacteristicList = [
  {
    description: (
      <span>
        {' '}
        <b>Premium Recessed 2.0 TM filter.</b>
        <br /> Фільтр складається з трьох частин:
      </span>
    ),
    bordered: false
  },
  {
    description: <span>Вугільна частина</span>,
    bordered: true
  },
  {
    description: (
      <span>
        Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким і
        більш збалансованим
      </span>
    ),
    bordered: true
  }
];

const characteristicInfoList = [
  {
    title: 'Формат ',
    description: '- King Size Slim (Кінг сайз слім)'
  },
  {
    title: 'Кількість сигарет у пачці ',
    description: '– 20'
  },
  {
    title: 'Кількість пачок у блоці ',
    description: '– 10'
  }
];

const menuList = [
  {
    id: 'challenge',
    screenNumber: 12,
    name: CURRENT_CHALLENGE_NAME,
    icon: 'images/common/menu-icon/may-challenge-menu-icon.svg'
  },
  {
    id: 'foresight',
    screenNumber: 27,
    name: 'Передбачення на сьогодні',
    icon: 'images/lm-double-splash/foresight-menu-icon.svg'
  },
  {
    id: 'characteristic',
    screenNumber: -1,
    name: 'Характеристики сигарет',
    icon: 'images/common/menu-icon/characteristic-menu-icon.svg'
  },
  {
    id: 'info',
    screenNumber: 3,
    name: 'Все про Філіп Морріс Україна',
    icon: 'images/common/menu-icon/info-menu-icon.svg'
  },
  {
    id: 'authority',
    screenNumber: 2,
    name: 'Як відрізнити підробку від оригіналу?',
    icon: 'images/common/menu-icon/authority-menu-icon.svg'
  },
  {
    id: 'review',
    screenNumber: 8,
    name: 'Залишити відгук про продукт',
    icon: 'images/common/menu-icon/review-menu-icon.svg'
  }
];

const partners = {
  cig: 'https://cig-poshta.in.ua/shop/chesterfield-ua/?utm_source=SP',
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=chesterfield/'
};

export const swipeChallenge = [
  {
    title: 'Декорації з вінілових платівок',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/9.png')
  },
  {
    title: 'Одяг у стилі тай-дай',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/8.png')
  },
  {
    title: 'Віртуальна реальність',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/7.png')
  },
  {
    title: 'Елементи ретро в дизайні',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/6.png')
  },
  {
    title: 'Комбуча',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/5.png')
  },
  {
    title: 'Йога',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/4.png')
  },
  {
    title: 'Настільні ігри',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/3.png')
  },
  {
    title: 'Елементи 80-х у одязі',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/2.png')
  },
  {
    title: 'Фольклорні мотиви в сучасній музиці',
    image: getImageFromS3('/images/chesterfield-6/november-challenge/1.png')
  }
];

const Chesterfield4Test = () => {
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 1,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init(PROJECT_NAME);
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case -1: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(26, false, { brandLine: brand });
            }}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 1: {
        return (
          <MenuScreen
            setScreenNumber={cb}
            menuList={menuList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 2: {
        return (
          <AuthorityScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(7)}
            partners={partners}
          />
        );
      }
      case 3: {
        return (
          <InfoScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(7)}
          />
        );
      }
      case 4: {
        return (
          <CharacteristicScreen
            title="CHESTERFIELD COMPACT SILVER"
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={filterCharacteristicList}
            infoList={characteristicInfoList}
            tobaccoFirst="Вміст смол, мг - 4"
            tobaccoSecond="Вміст нікотину, мг - 0.4"
            packImage={getImageFromS3('images/chesterfield-4/pack.png')}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(7)}
            backgroundImage={getImageFromS3(
              'images/chesterfield-4/background.png'
            )}
            filterIcon={getImageFromS3('images/chesterfield-4/filter-icon.png')}
          />
        );
      }
      case 5: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title="Обери з 2-х речей"
            description={`Тренди невпинно народжуються та змінюються.\n А ти намагаєшся встигнути за сучасними тенденціями чи обираєш вічну класику?`}
            buttonTitle="Пройти тест"
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(6)}
          />
        );
      }
      case 6: {
        return (
          <TwoImageSelectChallenge
            setScreenNumber={cb}
            challengeList={septemberChallengeList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            resultList={septemberResultList}
            setAfterResultScreen={() => setScreenNumber(25)}
          />
        );
      }
      case 25: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            setViewScreenNumber={() => setScreenNumber(4)}
            title="Згоден з результатами?"
            description={`Найкращий тренд сьогодні — це розвиток і самовдосконалення. А бути в тренді — значить ставати кращим щодня.\n Нижче можна зацінити, як покращився один відомий бренд.`}
            image={getImageFromS3(
              'images/chesterfield-6/september-challenge/result-info.png'
            )}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 7: {
        return (
          <FinalScreen
            setScreenNumber={cb}
            setScreenNumberToReview={() => setScreenNumber(8)}
            withReviewButton
            isUpdatedApp
          />
        );
      }
      case 8: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(24)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(8, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 9: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title="Модні тренди"
            description={`Усі знають, що мода циклічна.\n Ми підготували добірку модних трендів, які повернулися, щоб вразити всіх по-новому.`}
            buttonTitle="Дивитися"
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(10)}
          />
        );
      }
      case 10: {
        return (
          <OnlyImageChallenge
            challengeList={octoberChallengeList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setScreenNumber={setScreenNumber}
            setScreenNumberAfterResult={() => setScreenNumber(11)}
          />
        );
      }
      case 11: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            title={octoberResultList.title}
            description={octoberResultList.description}
            image={octoberResultList.image}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 12: {
        return (
          <MemoryChallenge
            setScreenNumber={cb}
            backgroundImage={`url("${getImageFromS3(
              'images/lm-special/background.png'
            )}")`}
            handleNextButtonClick={() => setScreenNumber(7)}
          />
        );
      }
      case 13: {
        return (
          <SwipeChallenge
            setScreenNumber={setScreenNumber}
            setScreenNumberAfterResult={() => setScreenNumber(14)}
            challengeList={swipeChallenge}
            challengeResultList={novemberResultList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 14: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            setViewScreenNumber={() => setScreenNumber(4)}
            title="Як тобі результат?"
            description={`Найкращий тренд сьогодні — це розвиток і самовдосконалення. А бути в тренді — значить ставати кращим щодня.\n\n Нижче можна зацінити, як покращився один відомий бренд.`}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 15: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title="Ідеї для персоналізації подарунків"
            description={`Усі люблять отримувати подарунки! Але важливо ще й уміти їх дарувати.\n\n Ми підготували кілька ідей, як зробити свій подарунок особливим і незабутнім.`}
            buttonTitle="Дивитися"
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(16)}
          />
        );
      }
      case 16: {
        return (
          <OnlyImageChallenge
            setScreenNumber={cb}
            challengeList={decemberChallengeList}
            setScreenNumberAfterResult={() => setScreenNumber(17)}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 17: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            title={decemberResultList.title}
            subtitle={decemberResultList.subtitle}
            description={decemberResultList.description}
            image={decemberResultList.image}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 18: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title="Що більше до вподоби"
            description={`Що тобі ближче: стримана вишуканість чи крейзі експерименти?\n Пройди тест і дізнайся!`}
            buttonTitle="Почати тест"
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(19)}
          />
        );
      }
      case 19: {
        return (
          <TwoImageSelectChallenge
            setScreenNumber={cb}
            challengeList={januaryChallengeList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            resultList={januaryResultList}
            setAfterResultScreen={() => setScreenNumber(20)}
          />
        );
      }
      case 20: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            title="Як тобі результат?"
            description="Яким би не був твій стиль, ми впевнені, що ти в ньому неперевершений."
            image={getImageFromS3(
              'images/chesterfield-6/january-challenge/result-info.png'
            )}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 21: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title="Оновлені тренди з минулого"
            description={`Як же круто, коли тренди повертаються!\n\n Ми підготували добірку колись підзабутих трендів для декору кімнати, що оновилися та зробили comeback.`}
            buttonTitle="Дивитися"
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(22)}
          />
        );
      }
      case 22: {
        return (
          <OnlyImageChallenge
            challengeList={februaryChallengeList}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
            setScreenNumber={setScreenNumber}
            setScreenNumberAfterResult={() => setScreenNumber(23)}
          />
        );
      }
      case 23: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(7)}
            title={februaryResultList.title}
            subtitle={februaryResultList.subtitle}
            description={februaryResultList.description}
            image={februaryResultList.image}
            backgroundImage={`url("${getImageFromS3(
              'images/chesterfield-4/background.png'
            )}")`}
          />
        );
      }
      case 24: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      case 26: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(-1, true)}
            nextButtonClick={() => setScreenNumber(7)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 27: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default Chesterfield4Test;
